import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

export function InfoRow(props: { label: string; value: string }) {
  return (
    <TableRow>
      <TableCell component="th" scope="row" sx={{ fontWeight: "bold", borderBottom: "none", pl: 0 }}>
        {props.label}
      </TableCell>
      <TableCell sx={{ borderBottom: "none" }}>{props.value}</TableCell>
    </TableRow>
  );
}
